import { render, staticRenderFns } from "./serverRecodeTxt.vue?vue&type=template&id=58d8c840&scoped=true"
import script from "./serverRecodeTxt.vue?vue&type=script&lang=js"
export * from "./serverRecodeTxt.vue?vue&type=script&lang=js"
import style0 from "./serverRecodeTxt.vue?vue&type=style&index=0&id=58d8c840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d8c840",
  null
  
)

export default component.exports